export default __webpack_public_path__ + "static/media/systems.12d8b801.svg";